var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7271 6.64557C27.2542 7.04722 27.356 7.80017 26.9543 8.32734L14.1543 25.1273C13.9445 25.4028 13.6258 25.5741 13.2803 25.5974C12.9348 25.6206 12.5961 25.4935 12.3513 25.2486L5.15128 18.0486C4.68265 17.58 4.68265 16.8202 5.15128 16.3516C5.61991 15.8829 6.3797 15.8829 6.84833 16.3516L13.0774 22.5807L25.0453 6.87284C25.4469 6.34567 26.1999 6.24392 26.7271 6.64557Z",
    fill: "#010F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1a6e43879ce3344ad93bafddf434d031.svg";
export { ForwardRef as ReactComponent };